import { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { CARD_METHOD } from 'payments-checkout-lib/constants/PaymentElement';
import BasicAddress from '../Address/BasicAddress';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import { setErrorMessages, getShowAllErrors } from '../../state/errorMessagesSlice';
import { useGetErrorMessagesAndTranslations } from '../../hooks/useGetErrorMessagesAndTranslations';
import CommonBillingAddress from './CommonBillingAddress';
import FullAddress from '../Address/FullAddress';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NameOnCardField = ({
  showAllErrors,
  collectShippingAddress,
  billingAddress,
  hasFullNameBeenBlurred,
  onChange,
  disabled,
  setHasFullNameBeenBlurred
}) => {
  const dispatch = useDispatch();
  const isError = (hasFullNameBeenBlurred || showAllErrors) && !billingAddress.fullName;
  useEffect(() => {
    dispatch(setErrorMessages({
      emptyNameOnCard: {
        isError
      }
    }));
  }, [isError, dispatch]);
  const nameOnCardErrorMessage = useGetErrorMessagesAndTranslations().get('emptyNameOnCard');
  const errorMessage = useMemo(() => {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "name-on-card-field-validation-message",
      children: nameOnCardErrorMessage
    });
  }, [nameOnCardErrorMessage]);
  return /*#__PURE__*/_jsx(FormControl, {
    "data-test-id": "name-on-card-field",
    marginBlockStart: collectShippingAddress ? '300' : '0',
    required: true,
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.billingInfo.nameOnCard"
    }),
    error: isError,
    validationMessage: isError && errorMessage,
    children: /*#__PURE__*/_jsx(TextInput, {
      "data-test-id": "full-name-input",
      value: billingAddress.fullName,
      onChange: event => onChange('fullName', event),
      disabled: disabled,
      use: "on-dark",
      onBlur: () => setHasFullNameBeenBlurred(true)
    })
  });
};
const CardBillingInfo = ({
  collectShippingAddress,
  collectFullBillingAddress,
  onChange,
  stripePaymentMethod
}) => {
  const {
    formState
  } = usePaymentFormContext();
  const showAllErrors = useSelector(getShowAllErrors);
  const disabled = formState.isCheckoutSubmitPending;
  const billingAddress = formState.billingAddress;
  const [hasFullNameBeenBlurred, setHasFullNameBeenBlurred] = useState(false);
  return /*#__PURE__*/_jsxs("span", {
    "data-test-id": "card-billing-info",
    children: [collectFullBillingAddress && /*#__PURE__*/_jsxs(CommonBillingAddress, {
      collectShippingAddress: collectShippingAddress,
      collectFullBillingAddress: collectFullBillingAddress,
      children: [/*#__PURE__*/_jsx(NameOnCardField, {
        showAllErrors: showAllErrors,
        collectShippingAddress: collectShippingAddress,
        billingAddress: billingAddress,
        hasFullNameBeenBlurred: hasFullNameBeenBlurred,
        onChange: onChange,
        disabled: disabled,
        setHasFullNameBeenBlurred: setHasFullNameBeenBlurred
      }), /*#__PURE__*/_jsx(FullAddress, {
        fullAddress: billingAddress,
        onChange: onChange
      })]
    }), !collectFullBillingAddress && collectShippingAddress && /*#__PURE__*/_jsxs(CommonBillingAddress, {
      collectShippingAddress: collectShippingAddress,
      collectFullBillingAddress: collectFullBillingAddress,
      children: [stripePaymentMethod === CARD_METHOD && /*#__PURE__*/_jsx(NameOnCardField, {
        showAllErrors: showAllErrors,
        collectShippingAddress: collectShippingAddress,
        billingAddress: billingAddress,
        hasFullNameBeenBlurred: hasFullNameBeenBlurred,
        onChange: onChange,
        disabled: disabled,
        setHasFullNameBeenBlurred: setHasFullNameBeenBlurred
      }), /*#__PURE__*/_jsx(BasicAddress, {
        postalCode: billingAddress.postalCode,
        country: billingAddress.country,
        onChange: onChange
      })]
    }), !collectShippingAddress && !collectFullBillingAddress && stripePaymentMethod === CARD_METHOD && /*#__PURE__*/_jsx(NameOnCardField, {
      showAllErrors: showAllErrors,
      collectShippingAddress: collectShippingAddress,
      billingAddress: billingAddress,
      hasFullNameBeenBlurred: hasFullNameBeenBlurred,
      onChange: onChange,
      disabled: disabled,
      setHasFullNameBeenBlurred: setHasFullNameBeenBlurred
    })]
  });
};
export default CardBillingInfo;